import dayjs from "dayjs";
export const moduleMap = {
  compliance: "Compliance ",
  reporting: "Email Report",
  analytics: "Analytics",
  stealth: "Stealth ",
  workplace: "Workplace Setting ",
  security: "Security ",
  overrides: "Overrides Configuration",
};

export const actionModuleMap: Record<string, string> = {
  UNKNOWN: "Unknown",
  TENANT_UPDATED: "Company Details Updated",
  TENANT_SETTINGS_CHANGED: "Global Setting Changed",
  GROUP_SETTINGS_CHANGED: "Group Settings",
  USER_INFO_CHANGED: "User Details Changed",
  SHIFT_CHANGED: "Shift Management",
  USER_CREATED: "User Created",
  USER_DEACTIVATED: "User DeActivated",
  USER_ACTIVATED: "User Activated",
  APP_DATA_PROCESSED: "App Data",
  LOCATION_DATA_PROCESSED: "Location Data",
  USER_PUNCHED_IN: "User Punched In",
  USER_PUNCHED_OUT: "User Punched Out",
  IDENTITY_CHANGED: "User Info Changed",
};

const timeOptions = [
  { value: 86399, label: "Never" },
  { value: 30, label: "30 Seconds" },
  { value: 60, label: "1 Minute" },
  { value: 120, label: "2 Minutes" },
  { value: 180, label: "3 Minutes" },
  { value: 300, label: "5 Minutes" },
  { value: 600, label: "10 Minutes" },
  { value: 900, label: "15 Minutes" },
  { value: 1200, label: "20 Minutes" },
  { value: 1800, label: "30 Minutes" },
  { value: 3600, label: "1 Hour" },
  { value: 7200, label: "2 Hours" },
];

export const getChangedModules = (oldObj = {}, newObj = {}, user: "") => {
  if (!oldObj || !newObj) return null;
  if (user) {
    return `User `;
  }
  const changedModules = [];

  Object.keys(moduleMap).forEach((key) => {
    const oldVal = oldObj[key];
    const newVal = newObj[key];

    if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
      changedModules.push(moduleMap[key]);
    }
  });

  return changedModules.length > 0 ? changedModules.join(", ") : "";
};
export const getLastFieldFromPath = (field: string) => {
  const parts = field.split(" / ");
  return parts[parts.length - 2]; // e.g. Snapshot Frequency
};
// export function getDifferenceData(record, team_map_data) {
//   const user = record?.meta?.user;
//   const differences = getCombinedDifferences(
//     record?.meta?.old,
//     record?.meta?.updated,
//     "", // starting path
//     user
//   );

//   if (user !== undefined && user !== null) {
//     return [String(user)]; // return as array for consistent format
//   }

//   const newData = Object.values(team_map_data);

//   const dataDiff = Object.entries(differences).map(([field, value]) => {
//     let displayField = field;
//     let displayValue = value;

//     if (displayField.toLowerCase().includes("path")) {
//       const pathId = String(displayField).split(":")[1]?.trim();
//       const matchedName = getGroupNameByPath(newData, pathId);
//       if (matchedName) {
//         displayValue = matchedName;
//       }
//     }

//     return `${
//       displayField.toLowerCase().includes("path") ? "Path" : displayField
//     }: ${String(displayValue)}`;
//   });

//   return dataDiff;
// }
export const getNameById = (data, id) => {
  const match = data.find((item) => item.id === id);
  return match ? match.name : null;
};

export const getItemById = (data, id) => {
  return data.find((item) => item.id === id) || null;
};
export const getCombinedDifferences = (
  oldObj: any,
  newObj: any,
  path = "",
  user?: any,
  shiftData = [],
  policyData = []
) => {
  const differences: Record<string, string> = {};

  const keys = new Set([
    ...Object.keys(oldObj || {}),
    ...Object.keys(newObj || {}),
  ]);

  for (const key of Array.from(keys)) {
    if (key === "created_date" || key === "last_modified_date") continue;

    const oldVal = oldObj?.[key];
    const newVal = newObj?.[key];

    const formattedKey = key
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
    const currentPath = path ? `${path} / ${formattedKey}` : formattedKey;

    const isCustomFieldsPath =
      currentPath === "Workplace / Custom Fields" ||
      (path === "Workplace" && key === "custom_fields");

    if (isCustomFieldsPath && Array.isArray(oldVal) && Array.isArray(newVal)) {
      const maxLength = Math.max(oldVal.length, newVal.length);
      for (let i = 0; i < maxLength; i++) {
        const oldField = oldVal[i];
        const newField = newVal[i];

        if (!oldField && newField) {
          const label = newField.label;
          differences[`${currentPath} / ${label}`] = `→ Added`;
          continue;
        }

        if (oldField && !newField) {
          const label = oldField.label;
          differences[`${currentPath} / ${label}`] = `→ Removed`;
          continue;
        }

        if (oldField && newField) {
          const label = oldField.label || `Field ${i + 1}`;

          if (oldField.label !== newField.label) {
            differences[
              `${currentPath} / label`
            ] = `${oldField.label}→ ${newField.label}`;
          }

          const allProps = new Set([
            ...Object.keys(oldField),
            ...Object.keys(newField),
          ]);
          for (const prop of Array.from(allProps)) {
            if (prop === "label") continue;
            const oldP = oldField[prop];
            const newP = newField[prop];
            if (JSON.stringify(oldP) !== JSON.stringify(newP)) {
              differences[
                `${currentPath} / ${prop} / ${label}`
              ] = `${oldP}→ ${newP}`;
            }
          }
        }
      }

      continue;
    }

    const isObject =
      typeof oldVal === "object" &&
      oldVal !== null &&
      typeof newVal === "object" &&
      newVal !== null &&
      !Array.isArray(oldVal) &&
      !Array.isArray(newVal);

    // ✅ Special handling if path is "Shift"
    if (path === "Shift") {
      const oldShift = getNameById(shiftData, oldObj?.id);
      const newShift = getNameById(shiftData, newObj?.id);

      if (oldShift && newShift) {
        const shiftKeys = new Set([
          ...Object.keys(oldShift),
          ...Object.keys(newShift),
        ]);

        for (const skey of Array.from(shiftKeys)) {
          if (["id", "created_date", "last_modified_date"].includes(skey))
            continue;

          const oldSVal = oldShift[skey];
          const newSVal = newShift[skey];

          if (JSON.stringify(oldSVal) !== JSON.stringify(newSVal)) {
            const label = skey
              .split("_")
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(" ");
            differences[`Shift / ${label}: ${oldSVal}`] = `→ ${newSVal}`;
          }
        }
        continue; // ✅ already handled this comparison
      }
    }

    // ✅ Special handling for Security object with keys like deny, allow, locations
    if (path === "Security" && isObject) {
      const secKeys = new Set([
        ...Object.keys(oldVal || {}),
        ...Object.keys(newVal || {}),
      ]);

      for (const sKey of Array.from(secKeys)) {
        const oldSecVal = oldVal?.[sKey];
        const newSecVal = newVal?.[sKey];

        if (JSON.stringify(oldSecVal) !== JSON.stringify(newSecVal)) {
          const label = sKey.charAt(0).toUpperCase() + sKey.slice(1);
          const oldDisplay = formatValue(sKey, oldSecVal);
          const newDisplay = formatValue(sKey, newSecVal);

          differences[`Security / ${label}: ${oldDisplay}`] = `→ ${newDisplay}`;
        }
      }

      continue;
    }

    if (isObject) {
      Object.assign(
        differences,
        getCombinedDifferences(
          oldVal,
          newVal,
          currentPath,
          user,
          shiftData,
          policyData
        )
      );
    } else if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
      let oldDisplay = formatValue(key, oldVal);
      let newDisplay = formatValue(key, newVal);

      differences[`${currentPath}: ${oldDisplay}`] = `→ ${newDisplay}`;
    }
  }

  if (user != null && typeof user === "string") {
    differences["User"] = user;
  }

  return differences;
};
const getTimeLabel = (value: number): string => {
  const match = timeOptions.find((opt) => opt.value === Number(value));
  return match ? match.label : String(value);
};

// ✅ Utility function to display values nicely

export const formatValue = (key: string, value: any): string => {
  const timeKeys = [
    "idle_timeout",
    "idle_timeout_threshold",
    "active_threshold",
  ];

  // ✅ Time keys formatting
  if (timeKeys.includes(key)) {
    const numericVal = Number(value);
    if (isNaN(numericVal)) return "—";
    return getTimeLabel(numericVal);
  }

  // ✅ Null or undefined
  if (value === null || value === undefined) return "null";

  // ✅ Date keys
  if ((key === "created_date" || key === "last_modified_date") && value) {
    const timestamp = typeof value === "number" ? value * 1000 : value;
    return dayjs(timestamp).format("YYYY-MM-DD hh:mm A");
  }

  // ✅ Convert minutes to hours
  const keysToConvertToHours = [
    "minimumActiveTimeMinutes",
    "minimumProductiveTimeMinutes",
    "full_time_minimum_minutes",
    "half_time_minimum_minutes",
    "maximum_punch_duration_minutes",
    "minimum_punch_duration_minutes",
  ];

  if (keysToConvertToHours.includes(key)) {
    const minutes = Number(value);
    if (!isNaN(minutes)) {
      const hours = minutes / 60;
      return `${hours} hours`;
    }
  }

  // ✅ Boolean formatting
  if (typeof value === "boolean") {
    return value ? "Enabled" : "Disabled";
  }

  // ✅ Array formatting
  if (Array.isArray(value)) {
    return value.length ? JSON.stringify(value) : "[]";
  }

  // ✅ Object formatting (fallback)
  if (typeof value === "object") {
    // Handle specific object shape like { name: "..." }
    if ("name" in value) {
      return value.name;
    }
    return JSON.stringify(value);
  }

  // ✅ Fallback: string conversion
  return String(value);
};

export const getGroupNameByPath = (groupData, pathId) => {
  for (const group of groupData) {
    const pathIds = group.path ? group.path.split(".") : [];
    if (pathIds.includes(pathId)) {
      return group.name;
    }
  }
  return null; // if not found
};

export function getDifferenceData(record, team_map_data) {
  const user = record?.meta?.user;
  const differences = getCombinedDifferences(
    record?.meta?.existing,
    record?.meta?.new,
    "", // starting path
    user
  );

  if (user !== undefined && user !== null) {
    return [String(user)]; // return as array for consistent format
  }

  const newData = Object.values(team_map_data);

  const dataDiff = Object.entries(differences).map(([field, value]) => {
    let displayField = field;
    let displayValue = value;

    if (displayField.toLowerCase().includes("path")) {
      const pathId = String(displayField).split(":")[1]?.trim();
      const matchedName = getGroupNameByPath(newData, pathId);
      if (matchedName) {
        displayValue = matchedName;
      }
    }

    return `${
      displayField.toLowerCase().includes("path") ? "Path" : displayField
    }: ${String(displayValue)}`;
  });

  return dataDiff;
}

export const getChangedPaths = (
  obj1: any,
  obj2: any,
  path = ""
): Set<string> => {
  const changedPaths = new Set<string>();

  const allKeys = new Set([
    ...Object.keys(obj1 || {}),
    ...Object.keys(obj2 || {}),
  ]);

  allKeys.forEach((key) => {
    const fullPath = path ? `${path}.${key}` : key;

    const val1 = obj1?.[key];
    const val2 = obj2?.[key];

    if (
      typeof val1 === "object" &&
      val1 !== null &&
      typeof val2 === "object" &&
      val2 !== null
    ) {
      const childChanges = getChangedPaths(val1, val2, fullPath);
      childChanges.forEach((p) => changedPaths.add(p));
    } else if (JSON.stringify(val1) !== JSON.stringify(val2)) {
      changedPaths.add(fullPath);
    }
  });

  return changedPaths;
};
export const highlightDiffJson = (
  obj: any,
  changedPaths: Set<string>,
  path = "",
  side: "existing" | "new"
): string => {
  if (typeof obj !== "object" || obj === null) {
    return JSON.stringify(obj);
  }

  const lines: string[] = ["{"];

  const keys = Object.keys(obj);
  keys.forEach((key, index) => {
    const fullPath = path ? `${path}.${key}` : key;
    const value = obj[key];
    const isChanged = changedPaths.has(fullPath);

    let valueString: string;

    if (typeof value === "object" && value !== null) {
      valueString = highlightDiffJson(value, changedPaths, fullPath, side);
    } else {
      valueString = JSON.stringify(value);
    }

    const comma = index === keys.length - 1 ? "" : ",";
    const line = `"${key}": ${valueString}${comma}`;

    if (isChanged) {
      const bgColor = side === "existing" ? "#ffe6e6" : "#e6ffe6"; // light red or green
      lines.push(
        `<span style="background-color: ${bgColor}; padding: 2px 4px;">${line}</span>`
      );
    } else {
      lines.push(line);
    }
  });

  lines.push("}");
  return lines.join("\n");
};
